import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { motion } from 'framer-motion';

import FormHeader from 'components/FormHeader/FormHeader';

import { OfferTypeCard } from './components/OfferTypeCard';
import { OFFER_TYPE_CARDS } from './consts';
import { OfferTypeCardConfig } from './types';

const FORM_HEADER_HEIGHT = 73;

const SelectOfferType = () => {
  const navigate = useNavigate();

  const handleClose = () => navigate('../');

  const handleSelectType = useCallback(
    (config: OfferTypeCardConfig) => {
      const params = new URLSearchParams({ type: config.offerDesignType });
      if (config.subType) {
        params.set('subType', config.subType);
      }
      navigate(`../form?${params.toString()}`);
    },
    [navigate]
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      className="bg-white fixed h-screen w-full top-0 left-0 z-[1000] overflow-hidden"
    >
      <FormHeader
        onCloseForm={handleClose}
        title="Create new offer design"
      />
      <div className={`flex-1 flex flex-col items-center pt-10 px-6 overflow-y-auto h-[calc(100vh-${FORM_HEADER_HEIGHT}px)]`}>
        <h2 className="text-xl font-semibold text-zinc-900 mb-1.5">
          Select Offer Type
        </h2>
        <p className="text-base font-normal text-base-mutedForeground mb-[30px]">
          Choose the type of offer design you want to create.
        </p>

        <div className="flex flex-wrap justify-center gap-[21px] max-w-[931px]">
          {OFFER_TYPE_CARDS.map((card) => (
            <OfferTypeCard
              key={card.key}
              config={card}
              onClick={handleSelectType}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default SelectOfferType;
